import { render, staticRenderFns } from "./SimplePaginator.vue?vue&type=template&id=4e1622b2&"
import script from "./SimplePaginator.vue?vue&type=script&lang=js&"
export * from "./SimplePaginator.vue?vue&type=script&lang=js&"
import style0 from "./SimplePaginator.vue?vue&type=style&index=0&id=4e1622b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports